var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": _vm.getId
    }
  }, [_c('RAFTFullScreenContent', {
    attrs: {
      "header-text": _vm.getMaterialTypeLabel
    }
  }, [_c('div', {
    class: {
      'table-ready': _vm.getUpdatingMaterialsStatus === 'success'
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.getEmailIconClass
  }, [!_vm.inLibrary ? _c('a', {
    attrs: {
      "id": "email-link",
      "href": "#",
      "title": "Email groups owning the listed biological materials"
    },
    on: {
      "click": _vm.redirectToEmail
    }
  }, [_c('b-img', {
    attrs: {
      "src": _vm.getEmailIconPath,
      "width": "24",
      "height": "24",
      "fluid": "",
      "alt": "Click to Email"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('BaseFilters', {
    attrs: {
      "filters": _vm.getFilters
    },
    on: {
      "update-filters": _vm.debouncedUpdateFilter
    }
  }), _vm._v(" "), _c('BaseTable', {
    ref: "table",
    attrs: {
      "items": _vm.getBioMaterials,
      "fields": _vm.getFields,
      "total-items": _vm.getTotalMaterials,
      "current-page": _vm.getCurrentPage,
      "is-busy": _vm.getBusy,
      "class-prefix": _vm.getId
    },
    on: {
      "update-current-page": _vm.updateCurrentPage
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function () {
        return [_c('div', {
          staticClass: "biologicals-empty-text"
        }, [_vm._v("\n          There are currently no '" + _vm._s(_vm.getMaterialTypeLabel) + "' biological\n          materials to list.\n        ")])];
      },
      proxy: true
    }, {
      key: "og-audience",
      fn: function (data) {
        return [_c('div', {
          staticClass: "bio-material-group"
        }, [_c('a', {
          attrs: {
            "href": data.data.value.url
          }
        }, [_vm._v("\n            " + _vm._s(data.data.value.text) + "\n          ")])])];
      }
    }, {
      key: "internal-link",
      fn: function (data) {
        return [_c('div', {
          staticClass: "bio-material-unlinked"
        }, [_c('a', {
          attrs: {
            "href": data.data.value.url + '?' + _vm.getDestinationQuery
          }
        }, [_vm._v(_vm._s(data.data.value.text))]), _vm._v(" "), !_vm.inLibrary && data.data.item.parent_reference === null ? _c('div', {
          staticClass: "bio-material-unlinked dog-ear"
        }) : _vm._e()])];
      }
    }, {
      key: "remove-link",
      fn: function (data) {
        return [_c('b-modal', {
          attrs: {
            "size": "xl",
            "scrollable": "",
            "id": _vm.getInternalId(data.data.item),
            "busy": _vm.getBusy,
            "ok-title": "Confirm",
            "centered": "",
            "title": 'Please confirm that you wish to remove this ' + _vm.getMaterialTypeLabel
          },
          on: {
            "ok": function ($event) {
              return _vm.removeMaterial(data.data.item);
            },
            "cancel": function ($event) {
              _vm.confirmBusy = false;
            },
            "close": function ($event) {
              _vm.confirmBusy = false;
            }
          }
        }, [_c('p', [_vm._v(_vm._s(_vm.getMaterialTypeLabel) + ": " + _vm._s(data.data.item.name))])]), _vm._v(" "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.removeGroupMaterial(data.data.item);
            }
          }
        }, [_vm._v("Remove")])];
      }
    }])
  }), _vm._v(" "), _vm.inLibrary ? _c('AddNewBioMaterial', {
    attrs: {
      "material-type": _vm.materialType,
      "material-type-label": _vm.getMaterialTypeLabel
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }